import { DocumentNode, gql } from "@apollo/client";

import { EVENT_PICKS_FRAGMENT } from "src/gql/queries";

// Cacheable
export const EUROPEAN_SOCCER_EVENTS: DocumentNode = gql`
  query europeanSoccerEventsQuery(
    $slugIds: [String!]!
    $league: LeagueEnum!
    $period: [LinePeriodEnum]
    $books: [UUID]
    $book: UUID!
    $lineType: [LineTypeEnum]
    $hasTeamPowerProjectionGrades: Boolean!
    $hasFGspreadPowerRating: Boolean!
    $hasFGmoneylinePowerRating: Boolean!
    $hasFGtotalPowerRating: Boolean!
    $has1HspreadPowerRating: Boolean!
    $has1HmoneylinePowerRating: Boolean!
    $has1HtotalPowerRating: Boolean!
    $has1PspreadPowerRating: Boolean!
    $has1PmoneylinePowerRating: Boolean!
    $has1PtotalPowerRating: Boolean!
  ) {
    gameweekEventsBySlugIds(
      slugIds: $slugIds,
      league: $league
    ) {
      ${EVENT_PICKS_FRAGMENT}
      projection @include(if: $hasTeamPowerProjectionGrades) {
        projHomeScore
        projAwayScore
        projHomeWinPercent
        projAwayWinPercent
        projHomeFirstHalfScore
        projAwayFirstHalfScore
        projHomeFirstHalfWinPercent
        projAwayFirstHalfWinPercent
        projHomeKeyPlayerGradeScore
        projHomeKeyPlayerGrade
        projAwayKeyPlayerGradeScore
        projAwayKeyPlayerGrade
        projHomeOffenseGradeScore
        projHomeOffenseGrade
        projAwayOffenseGradeScore
        projAwayOffenseGrade
        projHomeDefenseGradeScore
        projHomeDefenseGrade
        projAwayDefenseGradeScore
        projAwayDefenseGrade
        projHomeTeamGrade
        projHomeTeamGradeScore
        projAwayTeamGrade
        projAwayTeamGradeScore
        projHomeGoalie
        projAwayGoalie
        projHomeShots
        projHomeShotsOnGoal
        projAwayShots
        projAwayShotsOnGoal
      }
      spRating(bookUuid: $book) @include(if: $hasFGspreadPowerRating) {
        rating
        differential
        preferredLine
        preferredTeamId
      }
      mlRating(bookUuid: $book) @include(if: $hasFGmoneylinePowerRating) {
        rating
        differential
        preferredLine
        preferredTeamId
        preferredWinPercent
        preferredMoneyline
      }
      ouRating(bookUuid: $book) @include(if: $hasFGtotalPowerRating) {
        rating
        differential
        preferredLine
        preferredTotal
        preferredWinPercent
      }
      sp1HRating(bookUuid: $book) @include(if: $has1HspreadPowerRating) {
        rating
        differential
        preferredLine
        preferredTeamId
      }
      ml1HRating(bookUuid: $book) @include(if: $has1HmoneylinePowerRating) {
        rating
        differential
        preferredLine
        preferredTeamId
      }
      ou1HRating(bookUuid: $book) @include(if: $has1HtotalPowerRating) {
        rating
        differential
        preferredLine
        preferredTotal
      }
      sp1PRating(bookUuid: $book) @include(if: $has1PspreadPowerRating) {
        rating
        differential
        preferredLine
        preferredTeamId
      }
      ml1PRating(bookUuid: $book) @include(if: $has1PmoneylinePowerRating) {
        rating
        differential
        preferredLine
        preferredTeamId
      }
      ou1PRating(bookUuid: $book) @include(if: $has1PtotalPowerRating) {
        rating
        differential
        preferredLine
        preferredTotal
      }
      homeTeam {
        id
        fullName
        lastName
        preferredAbbreviation
        country
        conference
        division
        injuredPlayers {
          id
          fullName
          imageUrl
          injuryStatus
          active
          position
          depthOrder
          news(maxPriority: 3, injury: true) {
            id
            playerId
            title
            newsTime
          }
        }
        teamStats {
          id
          atsUnits
          atswins
          atslosses
          atsties
          atsWinPercent
          games
          netUnits
          overPercent
          overs
          pushes
          underPercent
          unders
          rank
          wins
          losses
          confWins
          confLosses
          homeSuWins
          awaySuWins
          homeSuLosses
          awaySuLosses
          homeSuTies
          awaySuTies
          homeAtsWins
          awayAtsWins
          homeAtsLosses
          awayAtsLosses
          homeAtsTies
          awayAtsTies
          homeOvers
          awayOvers
          homeUnders
          awayUnders
          homePushes
          awayPushes
        }
      }
      awayTeam {
        id
        fullName
        lastName
        preferredAbbreviation
        country
        conference
        division
        injuredPlayers {
          id
          fullName
          imageUrl
          injuryStatus
          active
          position
          depthOrder
          news(maxPriority: 3, injury: true) {
            id
            playerId
            title
            newsTime
          }
        }
        teamStats {
          id
          atsUnits
          atswins
          atslosses
          atsties
          atsWinPercent
          games
          netUnits
          overPercent
          overs
          pushes
          underPercent
          unders
          rank
          wins
          losses
          confWins
          confLosses
          homeSuWins
          awaySuWins
          homeSuLosses
          awaySuLosses
          homeSuTies
          awaySuTies
          homeAtsWins
          awayAtsWins
          homeAtsLosses
          awayAtsLosses
          homeAtsTies
          awayAtsTies
          homeOvers
          awayOvers
          homeUnders
          awayUnders
          homePushes
          awayPushes
        }
      }
      lines(bookIds: $books, period: $period, lineType: $lineType) {
        bookId
        book {
          id
          name
        }
        id
        time
        type
        lineType
        period
        awaySpread
        awayMoney
        awayPrice
        homeSpread
        homeMoney
        homePrice
        drawMoney
        total
        overPrice
        underPrice
      }
      eventStats(period: $period) {
        id
        period
        homeSpreadCount
        awaySpreadCount
        homeMoneyCount
        awayMoneyCount
        drawMoneyCount
        overCount
        underCount
        homeSharpSpreadPercent
        awaySharpSpreadPercent
        homeSharpMoneyPercent
        awaySharpMoneyPercent
        drawSharpMoneyPercent
        overSharpPercent
        underSharpPercent
        homeTicketSpreadPercent
        awayTicketSpreadPercent
        homeTicketMoneyPercent
        awayTicketMoneyPercent
        drawTicketMoneyPercent
        overTicketPercent
        underTicketPercent
        publicSpreadHome
        publicSpreadAway
        publicMoneyHome
        publicMoneyAway
        publicMoneyDraw
        publicTotalOver
        publicTotalUnder
      }
      eventTrends(bookUuid: $book, trendTypes: [ATS, ML, HTATS, OU]) {
        id
        teamId
        timePeriod
        description
        typeGames
        rating
        trendType
        reportType
        wins
        losses
        games
        units
      }
    }
  }
`;
